import React from 'react';

const Footer = () => {
  return (
   <footer className="w-full border-t-2 border-[#FFD199] py-3 ">
  <div className="max-w-6xl mx-auto text-center  text-gray-700 whitespace-wrap md:whitespace-nowrap overflow-hidden overflow-ellipsis text-sm">
    Copyright © 2025 All Rights Reserved by <span className="text-[#FF8E1C] font-medium">Incredible Leaders Pvt. Ltd.</span>
  </div>
</footer>

  );
};

export default Footer;
